export default "__VITE_ASSET__BPo_Slch__"